var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#52AA3F",
    id: "path3161",
    d: "M 23.999,14 C 23.99,13.867 24.013,11.703 23.122,9.297 22.67,8.097 21.972,6.805 20.797,5.755 19.632,4.7 17.945,3.984 16.001,4 14.054,3.983 12.367,4.7 11.202,5.755 9.443,7.344 8.741,9.414 8.365,11.029 8.001,12.656 8,13.902 8,14 H 6 V 30 H 26 V 14 h -2.001 z m -11.99,-0.238 c 0.025,-0.62 0.218,-2.335 0.86,-3.64 0.718,-1.327 1.37,-2.072 3.132,-2.124 1.053,0.016 1.615,0.3 2.138,0.747 0.773,0.658 1.335,1.965 1.593,3.163 0.134,0.59 0.203,1.14 0.236,1.527 0.033,0.383 0.026,0.562 0.031,0.565 h -8 c 0,-0.002 0,-0.06 0.01,-0.238 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock-closed.c056c86869b07c5f64e9ad115c03f70c.svg";
export { ForwardRef as ReactComponent };